
/* Open external links in new tab */
var all_links = document.querySelectorAll('a');
for (var i = 0; i < all_links.length; i++){
       var a = all_links[i];
       if(a.hostname != location.hostname) {
               a.rel = 'noopener';
               a.target = '_blank';
       }
}

/* Header Sticky fix */
  document.addEventListener("scroll", function() {
    const header = document.querySelector("header");
    // Use a breakpoint of 768px to differentiate desktop from mobile (adjust if needed)
    const threshold = (window.innerWidth >= 768) ? 140 : 90;
    if (window.scrollY <= threshold) {
      header.style.visibility = "visible";
    }
  });

/* Promo Scroll + Arrows */
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('offerScrollContainer');
  if (!container) return;

  const prevBtn = document.querySelector('[data-offers-arrow="prev"]');
  const nextBtn = document.querySelector('[data-offers-arrow="next"]');

  let currentIndex = 0;
  let interval = null;
  const AUTOPLAY_MS = 5000;

  const getBlocks = () => Array.from(container.children).filter(Boolean);

  function scrollToIndex(index, behavior = 'smooth') {
    const blocks = getBlocks();
    if (!blocks.length) return;

    // wrap index
    currentIndex = (index + blocks.length) % blocks.length;

    container.scrollTo({
      left: container.clientWidth * currentIndex,
      behavior
    });
  }

  function scrollToNext() {
    scrollToIndex(currentIndex + 1);
  }

  function scrollToPrev() {
    scrollToIndex(currentIndex - 1);
  }

  function startAutoScroll() {
    stopAutoScroll(); // avoid duplicates
    const blocks = getBlocks();
    if (blocks.length <= 1) return; // no need to autoplay
    interval = setInterval(scrollToNext, AUTOPLAY_MS);
  }

  function stopAutoScroll() {
    if (interval) clearInterval(interval);
    interval = null;
  }

  function restartAutoScroll() {
    startAutoScroll();
  }

  // Click arrows
  if (prevBtn) {
    prevBtn.addEventListener('click', (e) => {
      e.preventDefault();
      stopAutoScroll();
      scrollToPrev();
      restartAutoScroll();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', (e) => {
      e.preventDefault();
      stopAutoScroll();
      scrollToNext();
      restartAutoScroll();
    });
  }

  // Pause on hover (desktop)
  container.addEventListener('mouseenter', stopAutoScroll);
  container.addEventListener('mouseleave', startAutoScroll);

  // Track user swipe/scroll to keep index in sync
  container.addEventListener('scroll', () => {
    const width = container.clientWidth || 1;
    currentIndex = Math.round(container.scrollLeft / width);
  }, { passive: true });

  // Keep index correct if resized (e.g. orientation change)
  window.addEventListener('resize', () => {
    // jump to same index without animation to avoid weird mid-slide positions
    scrollToIndex(currentIndex, 'auto');
  });

  startAutoScroll();
});

/* UC Dynamic Content Drawer (uses Impact's built-in x-drawer) */
(function() {
  function ucOpenProductAccordions(container) {
    const descriptionAccordion = container.querySelector(
      '.product-info__block-item[data-block-type="collapsible-text"] details'
    );
    if (!descriptionAccordion) return;
    descriptionAccordion.open = true;
    descriptionAccordion.setAttribute('aria-expanded', 'true');
    const content = descriptionAccordion.querySelector('.accordion__content');
    if (content) {
      content.style.opacity = '1';
      content.style.transform = 'none';
    }
  }

  // The options engine mounted into the drawer, if the product in it has any.
  // Held here so the next open can destroy it before mounting another.
  let ucDrawerOptions = null;

  // Loads the options engine on a page that did not ship it.
  //
  // theme.liquid only loads it on product pages — it is 42KB gzipped, and every
  // other page needs it for nothing. A quick view is the exception: it puts a
  // whole product page on screen, so it needs the engine after all. The URLs
  // come from window.UC_OPTIONS_LAZY, published by theme.liquid on exactly the
  // pages that did not load it.
  //
  // The promise is cached, so a second quick view reuses the first load rather
  // than racing another copy in.
  //
  // ORDER IS REQUIRED, not incidental: the engine reads window.UC_OPTIONS_RULES
  // as it boots, so the rules must have finished executing before it starts.
  let ucOptionsEngine = null;
  const ucEngineReady = () => typeof window.UCOptions?.boot === 'function';
  function ucLoadOptionsEngine() {
    // `window.UCOptions` EXISTS ON EVERY PAGE. uc-cart.js creates it and hangs
    // its own exports off it, so testing the object found it already there and
    // never loaded the engine — then `UCOptions.boot` was not a function.
    // `boot` is the thing that only the full engine provides.
    if (ucEngineReady()) return Promise.resolve(true);
    if (ucOptionsEngine) return ucOptionsEngine;
    const urls = window.UC_OPTIONS_LAZY;
    if (!urls || !urls.rules || !urls.engine) return Promise.resolve(false);

    const load = (src) => new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.onload = () => resolve();
      s.onerror = () => reject(new Error('failed to load ' + src));
      document.head.appendChild(s);
    });

    ucOptionsEngine = load(urls.rules)
      .then(() => load(urls.engine))
      .then(() => ucEngineReady())
      .catch((err) => {
        console.error('[uc-drawer] options engine failed to load', err);
        // Let a later drawer try again rather than caching the failure.
        ucOptionsEngine = null;
        return false;
      });
    return ucOptionsEngine;
  }

  function ucOpenDrawer(event, trigger) {
    event.preventDefault();
    const drawer = document.getElementById('uc-drawer');
    const titleEl = document.getElementById('uc-drawer-title');
    const contentEl = document.getElementById('uc-drawer-content');
    let url = trigger.getAttribute('data-url');
    // Triggers are wired via inline onclick in section JSON, so a missing
    // data-url is possible; bail before preventDefault swallows the click.
    if (!url) return;

    // Handle hash anchors
    let hash = null;
    if (url.includes('#')) {
      const parts = url.split('#');
      url = parts[0];
      // '/x#' would yield '#', and querySelector('#') throws a SyntaxError.
      hash = parts[1] ? '#' + parts[1] : null;
    }

    // Clear any previous quick-view styling. These classes were only ever
    // added, never removed, so once a Ready-Made quick view had been opened
    // every later drawer (offers page, returns policy, cart upsell) inherited
    // its CSS - zeroed padding, hidden ratings - until a full page reload.
    contentEl.classList.remove('uc-drawer--quickview');
    drawer.classList.remove('uc-drawer--quickview-active');

    // Token guards against a slow first request overwriting a newer one.
    const requestToken = (ucOpenDrawer._token = (ucOpenDrawer._token || 0) + 1);

    // Show loading state and open drawer via x-drawer API
    contentEl.innerHTML = 'Loading content...';
    titleEl.textContent = 'Loading...';
    drawer.show();

    // Fetch and render content
    fetch(url)
      .then(response => {
        // Shopify's 404 page also has #main, so without this check a renamed
        // or unpublished product renders as a stripped 404 titled "Drawer".
        if (!response.ok) throw new Error('HTTP ' + response.status + ' for ' + url);
        return response.text();
      })
      .then(html => {
        // A newer click superseded this one - drop the stale response.
        if (requestToken !== ucOpenDrawer._token) return;
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const mainContent = doc.querySelector('#main');

        // Update drawer title
        let title = 'Drawer';
        if (trigger.getAttribute('data-url').includes('/products/')) {
          const productTitle = doc.querySelector('.product-info__title');
          if (productTitle) title = productTitle.textContent.trim();
        } else {
          const pageTitle = doc.querySelector('title');
          if (pageTitle) title = pageTitle.textContent.trim();
        }
        titleEl.textContent = title;

        // Remove unwanted elements
        if (mainContent) {
          mainContent.querySelectorAll('.shopify-section-group-footer-group').forEach(el => el.remove());
          mainContent.querySelectorAll('h1').forEach(el => el.remove());

          if (trigger.getAttribute('data-url').includes('/products/')) {
            mainContent.querySelectorAll('.h2').forEach(el => el.remove());
            mainContent.querySelectorAll('.breadcrumb').forEach(el => el.remove());
            mainContent.querySelectorAll('.shopify-section--rich-text').forEach(el => el.remove());
            mainContent.querySelectorAll('.jdgm-review-widget').forEach(el => el.remove());
            mainContent.querySelectorAll('.shopify-section--product-recommendations').forEach(el => el.remove());
            mainContent.querySelectorAll('.shopify-section--recently-viewed-products').forEach(el => el.remove());
            mainContent.querySelectorAll('.product-info__payment-terms').forEach(el => el.remove());
          }

          contentEl.innerHTML = mainContent.innerHTML;

          // Re-execute injected <script> tags so anything inline can run.
          contentEl.querySelectorAll('script').forEach(oldScript => {
            const s = document.createElement('script');
            for (const attr of oldScript.attributes) s.setAttribute(attr.name, attr.value);
            s.text = oldScript.textContent;
            oldScript.parentNode.replaceChild(s, oldScript);
          });

          // ─── Quick-view treatment (eye-button on Ready Made cards only) ───
          // The trigger sets data-quickview="ready-made". We strip everything
          // except the first .shopify-section (the main-product section) so the
          // drawer shows just the product info — images, title, price, variant
          // picker, add-to-cart, description. No related products, no reviews.
          // Drawer uses from other triggers (no data-quickview) are unaffected.
          if (trigger.getAttribute('data-quickview') === 'ready-made') {
            // Keep the main-product section specifically. Do NOT assume it is
            // first: on Sinnovator a custom-liquid section precedes it, and
            // keeping index 0 deleted the product entirely.
            const sections = Array.from(contentEl.querySelectorAll('.shopify-section'));
            const keep = sections.find(s =>
              s.classList.contains('shopify-section--main-product') || s.querySelector('.product-info')
            ) || sections[0];
            sections.forEach(sec => { if (sec !== keep) sec.remove(); });

            // Scope class so all quickview-specific CSS only targets here.
            contentEl.classList.add('uc-drawer--quickview');
            drawer.classList.add('uc-drawer--quickview-active');

            // Order the top of the drawer: price, then the facts and options,
            // then Add to cart.
            //
            // The buy-buttons block was moved to sit directly under the price
            // so the customer did not have to scroll a whole PDP to buy. That
            // put it ABOVE the options, which was harmless while a ready-made
            // had none and wrong the moment it did — the button came before the
            // choices it commits.
            //
            // The options block carries the facts panel at its top (firmness,
            // size, ref), so moving it up as one piece gives: what this object
            // is, what you can add to it, then buy.
            const priceBlock = contentEl.querySelector('.product-info__block-item[data-block-type="price"]');
            const optionsBlock = contentEl.querySelector('.product-info__block-item[data-block-type="uc-options"], .product-info__block-item[data-block-type="uc_options"]');
            const buyButtonsBlock = contentEl.querySelector('.product-info__block-item[data-block-type="buy-buttons"], .product-info__block-item[data-block-type="buy_buttons"]');

            // Whatever is highest so far, so each moves after the last one
            // placed rather than all three landing in reverse.
            let after = priceBlock;
            for (const block of [optionsBlock, buyButtonsBlock]) {
              if (!block || !after || block === after) continue;
              after.insertAdjacentElement('afterend', block);
              after = block;
            }

            // Move the custom badges ("Ready-Made") onto the price line.
            //
            // product-info.liquid renders custom badges beside the TITLE, and
            // quick view deletes the title — so the badge was left stranded on
            // a line of its own above the price, which is what it looked like.
            //
            // Appended LAST so it follows the discount badge rather than
            // displacing it: the price block already holds sold-out and
            // discount, and those belong nearer the number they modify.
            //
            // No styling needed. `.product-info__price .rating-with-text` is a
            // flex row and `.product-info__price .product-info__badge-list`
            // already centres and spaces a badge list inside it, so the badge
            // simply inherits the treatment the discount badge has.
            const priceRow = contentEl.querySelector('.product-info__price .rating-with-text');
            if (priceRow) {
              contentEl.querySelectorAll('.product-info__badge-list').forEach(list => {
                // Leave the ones already on the price line where they are.
                if (list.closest('.product-info__price')) return;
                priceRow.appendChild(list);
              });
            }

            // Strip blocks that render invisibly but still take vertical space:
            //   - variant-picker (Ready Mades have 1 variant)
            //   - LPO app block (empty placeholder Cloudlift can't bind to)
            //   - collapsible-text accordions whose body is empty (e.g. Description
            //     when product.description is blank)
            //   - any block whose visible text+media content is empty
            contentEl.querySelectorAll('.product-info__block-item').forEach(block => {
              const type = block.getAttribute('data-block-type');
              if (type === 'variant-picker' || type === 'variant_picker') {
                block.remove();
                return;
              }
              // Empty LPO placeholder
              if (block.querySelector('[data-live-options]')) {
                block.remove();
                return;
              }
              // Collapsible-text with empty body (Description when product.description is blank)
              if (type === 'collapsible-text' || type === 'collapsible_text') {
                const body = block.querySelector('.accordion__content');
                if (body && body.textContent.trim().length === 0) {
                  block.remove();
                  return;
                }
              }
              // The options block is EMPTY UNTIL THE ENGINE RENDERS INTO IT,
              // and the engine is booted below, after this stripping pass. So
              // "no text, no media" is true of it here and would be true only
              // here — the block that carries every option on the product would
              // be removed moments before it filled itself in.
              if (block.querySelector('[data-uc-options-root]')) return;

              // Block has no visible text and no media — pure empty spacer
              const hasText = block.textContent.trim().length > 0;
              const hasMedia = block.querySelector('img, svg, video, iframe, picture, hr, input, button');
              if (!hasText && !hasMedia) {
                block.remove();
              }
            });
          }

          // ─── Options engine, for the product now in the drawer ───────────
          //
          // The drawer holds a WHOLE OTHER PRODUCT, so it needs an engine of
          // its own: `boot()` captures one product and one set of prices, and
          // the page's instance captured the page's.
          //
          // ORDER IS THE MECHANISM. The injected markup carries its own
          // <script> setting UC_OPTIONS_PRODUCT and the price maps; those were
          // re-executed above, so the globals now describe THIS product, and
          // boot reads them from the same place the page read its own. Boot any
          // earlier and it configures the wrong product; the page's instance is
          // unaffected either way, having closed over its own values already.
          //
          // `cart: false` because the shop-wide cart work is already running —
          // opening a drawer is not arriving at a new shop.
          //
          // The previous drawer's instance is destroyed FIRST. Its listeners
          // sit on the document, so without this every quick view leaves one
          // more behind, each still holding the product it was opened for, and
          // they all answer the next add to cart.
          try {
            if (ucDrawerOptions) ucDrawerOptions.destroy();
          } catch (err) {
            console.error('[uc-drawer] tearing down the previous options engine', err);
          }
          ucDrawerOptions = null;

          if (contentEl.querySelector('[data-uc-options-root]')) {
            // The engine may need fetching first, on a page that did not ship
            // it. The token check that follows is the same guard the fetch
            // above uses: by the time this resolves the customer may have
            // opened a different product, and mounting into content that has
            // since been replaced puts one product's options on another.
            ucLoadOptionsEngine().then((ready) => {
              if (!ready || requestToken !== ucOpenDrawer._token) return;
              if (!contentEl.querySelector('[data-uc-options-root]')) return;
              try {
                ucDrawerOptions = window.UCOptions.boot({ scope: contentEl, cart: false });
              } catch (err) {
                // The product still adds without options rather than not at all.
                console.error('[uc-drawer] options engine failed to boot', err);
              }
            });
          }

          // A Size Guide link whose target is not in here points at nothing.
          //
          // The link is rendered by the PDP - from the ready-made facts box, or
          // from under the variant selectors - and the drawer injects that same
          // markup. But a quick view keeps only the main-product section, and the
          // size-guide TABLE is a different section, so the anchor it jumps to was
          // stripped moments ago. Tapping it did nothing at all.
          //
          // The theme already has the idea: size-guide-link takes hide_size_chart,
          // documented as "quick buy has no anchor on the page". Liquid cannot help
          // here though - the drawer fetches the ordinary product page, so the link
          // is in the HTML before anything is stripped. Whoever removes the target
          // has to remove the link.
          //
          // Checked against the content rather than assumed: a drawer opened from
          // the offers bar or a cart upsell keeps every section, target included,
          // and there the link works and is left alone.
          contentEl.querySelectorAll('a.size-guide').forEach(link => {
            const href = link.getAttribute('href') || '';
            // '#' alone is a valid href and an invalid selector - querySelector
            // throws a SyntaxError on it, inside a promise, where it goes unseen.
            if (href.length < 2 || href.charAt(0) !== '#') return;
            if (!contentEl.querySelector(href)) link.remove();
          });

          // Auto-open product description accordion (but NOT for Ready Made
          // quick views — user wants those to start collapsed).
          if (trigger.getAttribute('data-url').includes('/products/') &&
              trigger.getAttribute('data-quickview') !== 'ready-made') {
            setTimeout(() => ucOpenProductAccordions(contentEl), 50);
          }

          // Scroll to hash anchor if present
          if (hash) {
            setTimeout(() => {
              const targetElement = contentEl.querySelector(hash);
              if (targetElement) targetElement.scrollIntoView({ behavior: 'smooth' });
            }, 100);
          }
        } else {
          contentEl.innerHTML = 'Failed to load content. Please try again.';
        }
      })
      .catch((err) => {
        // Logged so a bug in the render/strip logic is distinguishable from
        // an actual network failure.
        console.error('[uc-drawer]', err);
        if (requestToken !== ucOpenDrawer._token) return;
        contentEl.innerHTML = 'Failed to load content. Please try again.';
      });
  }

  function ucCloseDrawer() {
    document.getElementById('uc-drawer').hide();
  }

  // Tear the drawer's options engine down when the drawer actually closes,
  // however it closed — the close button, the backdrop, Escape, or
  // ucCloseDrawer. `dialog:after-hide` is the one signal all four reach.
  //
  // Destroying on next-open alone was not enough: the colour picker is portalled
  // to <body> to escape the transformed section around it, so it OUTLIVES the
  // drawer content that was replaced, and the scroll lock it puts on <html>
  // goes with it. Closing the drawer mid-pick left the page unscrollable.
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('uc-drawer');
    if (!drawer) return;
    drawer.addEventListener('dialog:after-hide', () => {
      if (!ucDrawerOptions) return;
      try {
        ucDrawerOptions.destroy();
      } catch (err) {
        console.error('[uc-drawer] tearing down the options engine on close', err);
      }
      ucDrawerOptions = null;
    });
  });

  // Auto-close drawer on add-to-cart button click
  document.addEventListener('click', (event) => {
    const atc = event.target.closest && event.target.closest('button.button.button--xl[is="custom-button"]');
    // Scope to the drawer: this selector also matches every PDP add-to-cart,
    // so an unscoped handler closed a quick view opened within 1.5s of one.
    if (atc && atc.closest('#uc-drawer')) {
      setTimeout(() => ucCloseDrawer(), 1500);
    }
  });

  window.ucOpenDrawer = ucOpenDrawer;
  window.ucCloseDrawer = ucCloseDrawer;
})();

// Basic Countdown Timer

document.addEventListener("DOMContentLoaded", () => {
  const timers = document.querySelectorAll(".simple-countdown[data-end-at]");
  if (!timers.length) return;

  function pad(n) {
    return String(n).padStart(2, "0");
  }

  function tick() {
    const now = Date.now();

    timers.forEach((el) => {
      const endRaw = el.getAttribute("data-end-at");
      const end = new Date(endRaw).getTime();

      if (!end || Number.isNaN(end)) return;

      const diff = end - now;

            // ✅ Hide when finished
      if (diff <= 0) {
        // Hide the whole block so the "Next drop:" label goes with the timer.
        // Falls back to the element itself for countdowns used elsewhere.
        const wrapper = el.closest(".hero-banner__countdown") || el;
        wrapper.style.display = "none";
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      el.innerHTML = `
  ${pad(days)} <span class="countdown-label">D</span>
  ${pad(hours)} <span class="countdown-label">H</span>
  ${pad(minutes)} <span class="countdown-label">M</span>
  ${pad(seconds)} <span class="countdown-label">S</span>
`;
    });
  }

  tick();
  setInterval(tick, 1000);
});


/* ==================================================================================================
   PRODUCT GALLERY — review slide support + desktop thumbnail hover
   ================================================================================================== */
(function () {
  /* ---------------------------------------------------------------------------------------------
     1. Variant-change index correction
     The gallery injects synthetic slides -- the review summary, and any is_scale social video.
     Liquid shifts the indices it emits (initial-index, filtered-indexes), but theme.js computes
     the target itself on variant change:
         newMediaPosition = variant.featured_media.position - 1
     which is short by however many synthetic slides come first.

     This used to look for the review slide alone and add at most one, so adding the video slide
     broke it twice over: the shift was one too small on products with both, and on a product
     with a video but no review summary the correction did not run at all -- which is the
     "X-Small shows the image before the right one" report.

     Counting is gone. Real media slides carry data-media-id and synthetic ones do not, so walk
     the children and find the Nth real one; its DOM index is the answer whatever else has been
     inserted, and wherever. Hidden slides (filtered out for the chosen variant) stay in the DOM
     and still count, which is what media.position does too.
     --------------------------------------------------------------------------------------------- */
  function correctedIndex(carousel, mediaPosition) {
    const slides = Array.from(carousel.children);
    let realSeen = 0;

    for (let i = 0; i < slides.length; i++) {
      if (!slides[i].hasAttribute('data-media-id')) continue;

      realSeen += 1;
      if (realSeen === mediaPosition) return i;
    }

    return mediaPosition - 1;
  }

  function hasSyntheticSlides(gallery) {
    return Array.from(gallery.querySelectorAll('.product-gallery__media'))
      .some((slide) => !slide.hasAttribute('data-media-id'));
  }

  /* Mirror theme.js's own condition for moving the gallery. It only re-selects when the featured
     media actually changes; re-selecting on every variant:change would yank a customer off a slide
     they had scrolled to whenever two variants share one image. */
  function movesGallery(detail) {
    const previous = detail.previousVariant;
    if (previous == null) return true;
    if (!previous.featured_media) return true;
    return previous.featured_media.id !== detail.variant.featured_media.id;
  }

  document.addEventListener('variant:change', (event) => {
    const detail = event.detail;
    const variant = detail && detail.variant;
    if (!variant || !variant.featured_media) return;
    if (!movesGallery(detail)) return;

    /* Read the form id with getAttribute, and ONLY with getAttribute.
       HTMLFormElement's named-property getter overrides built-in properties, and the product form
       carries <input name="id"> for the variant id - so `form.id` is that INPUT element, not the
       id string. It stringifies to "[object HTMLInputElement]", which matches no gallery, and this
       whole correction silently never ran.
       theme.js's own detail.formId is built from `form.id`, so it is the SAME input element and is
       equally unusable. Do not "simplify" this back to either one. */
    const form = event.target;
    const formId = form && form.getAttribute ? form.getAttribute('id') : null;
    const gallery = formId ? document.querySelector(`product-gallery[form="${formId}"]`) : null;
    if (!gallery || !hasSyntheticSlides(gallery)) return;

    gallery.querySelectorAll('media-carousel').forEach((carousel) => {
      if (typeof carousel.select !== 'function') return;
      carousel.select(correctedIndex(carousel, variant.featured_media.position), { animate: false });
    });
  });

  /* ---------------------------------------------------------------------------------------------
     2. Keep the prev/next hover cursor on the review slide
     theme.js hides <custom-cursor> whenever the selected slide's data-media-type isn't "image"
     (so it disappears on video/model slides). Our review slide is still a normal navigable slide,
     so put the cursor back when it's the one selected.
     --------------------------------------------------------------------------------------------- */
  document.addEventListener('carousel:change', (event) => {
    const gallery = event.target.closest && event.target.closest('product-gallery');
    if (!gallery) return;

    const cursor = gallery.querySelector('.product-gallery__cursor');
    const slide = event.detail && event.detail.slide;
    if (!cursor || !slide) return;

    if (slide.getAttribute('data-media-type') === 'review') {
      // Runs after theme.js's own handler, so this wins.
      cursor.removeAttribute('hidden');
    }
  });

  /* ---------------------------------------------------------------------------------------------
     3. Click-to-navigate on the review slide
     theme.js `_onGalleryClick` bails whenever the selected slide isn't an image — that guard exists
     to stop clicks hijacking video/model slides, but it also kills prev/next on our review slide.

     This MUST run in the capture phase. theme.js binds its handler on <media-carousel>, so a
     bubble-phase listener would see `selectedSlide` *after* theme.js had already advanced —
     landing us one slide too far and appearing to skip the review slide. Capturing at the document
     lets us read the pre-click selection, and stopPropagation keeps theme.js from acting on the
     same click (it would otherwise navigate again, now that an image is selected).
     --------------------------------------------------------------------------------------------- */
  document.addEventListener('click', (event) => {
    // Mirror theme.js's own guards
    if (event.target.closest('button, a[href]')) return;
    if (!window.matchMedia('screen and (pointer: fine)').matches) return;

    const carousel = event.target.closest && event.target.closest('media-carousel');
    if (!carousel || typeof carousel.next !== 'function') return;

    const selected = carousel.selectedSlide;
    if (!selected || selected.getAttribute('data-media-type') !== 'review') return;

    event.stopPropagation();

    const rect = carousel.getBoundingClientRect();
    if (event.clientX - rect.left > carousel.clientWidth / 2) {
      carousel.next();
    } else {
      carousel.previous();
    }
  }, true);

  /* ---------------------------------------------------------------------------------------------
     4. "Read all N" → scroll to the Judge.me widget
     There is no #shopify-product-reviews anchor in this theme — Judge.me injects its widget at
     runtime with no stable id, and the wrapping section id differs per template. So resolve the
     widget by its own class at click time and scroll to it. The href stays as a no-JS fallback.
     --------------------------------------------------------------------------------------------- */
  const REVIEW_WIDGET_SELECTOR = [
    '.jm-review-widget',
    '.jdgm-review-widget',
    '.jdgm-rev-widg',
    '#judgeme_product_reviews'
  ].join(', ');

  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('.product-gallery__review-link');
    if (!link) return;

    const widget = document.querySelector(REVIEW_WIDGET_SELECTOR);
    if (!widget) return; // let the href do whatever it can

    event.preventDefault();

    // Prefer the enclosing section so the "Customer Reviews" heading is in view too
    const target = widget.closest('.shopify-section') || widget;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------------------------------------------------------------------------------------------
     5. Desktop: hovering a thumbnail swaps the main image
     Opt-in via the "Change image on thumbnail hover" setting, which adds
     .product-gallery--thumbnail-hover. Pointer-fine only, so touch devices keep tap-to-select.
     --------------------------------------------------------------------------------------------- */
  // Long enough that sweeping the cursor down a tall rail no longer fires on every thumbnail it
  // crosses - only on the one the pointer actually settles on. 60 -> 160 -> 280ms, each on request.
  const HOVER_DELAY = 280;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  document.addEventListener('mouseover', (event) => {
    if (!finePointer.matches) return;

    const thumb = event.target.closest && event.target.closest('.product-gallery__thumbnail');
    if (!thumb) return;

    const gallery = thumb.closest('product-gallery.product-gallery--thumbnail-hover');
    if (!gallery) return;

    const list = thumb.parentElement;
    if (!list) return;

    const index = Array.from(list.children).indexOf(thumb);
    if (index === -1) return;

    clearTimeout(list._ucHoverTimer);
    list._ucHoverTimer = setTimeout(() => {
      gallery.querySelectorAll('media-carousel').forEach((carousel) => {
        if (typeof carousel.select === 'function') {
          carousel.select(index, { animate: false });
        }
      });
    }, HOVER_DELAY);
  });

  document.addEventListener('mouseout', (event) => {
    const thumb = event.target.closest && event.target.closest('.product-gallery__thumbnail');
    if (thumb && thumb.parentElement) clearTimeout(thumb.parentElement._ucHoverTimer);
  });

  /* ---------------------------------------------------------------------------------------------
     5a. Play the social video when it is BOTH the selected slide and on screen

     Neither condition is sufficient on its own. Visibility alone restarted the clip every time
     the page scrolled back past the gallery, whatever slide it was on. Selection alone plays a
     video nobody is looking at. An IntersectionObserver supplies the first and carousel events
     supply the second; see ucApplySocialState.

     Why the element and not the component: <video-media> exposes play()/pause(), but going
     through them does NOT start this video. Measured on the draft -- after vm.play() the element
     gains `loaded` and `can-play`, and stays paused at 0; v.play() on the same element plays it.
     So the component's player proxy is the part that does not deliver, and the rest of it is
     perfectly good.

     Touching `.player` once at setup is what keeps the component whole: that getter runs
     _playerTarget(), which sets `loaded` (without which theme.css keeps the <video> hidden behind
     the poster), marks `can-play`, and attaches the play/pause listeners that maintain the
     `playing` attribute. `playing` is what drives group pausing, so one clip still silences
     another. After that, playing the element directly feeds the component rather than bypassing
     it.
     --------------------------------------------------------------------------------------------- */
  const SOCIAL_VISIBLE_RATIO = 0.6;   // most of the clip showing, not a sliver at the edge

  /* Returns a promise, and callers must wait on it before playing. Preparation is asynchronous
     -- it waits for the custom element to be upgraded -- and playing before it has finished is
     exactly the first-play failure: the very first selection after a page load asked a video
     that was still hidden and unwired to play, and only the second one worked. */
  function ucPrepareSocialMedia(media) {
    if (media._ucPrepared) return media._ucPrepared;

    // The element may not be upgraded yet -- custom.js is deferred and theme.js is a module, so
    // `player` can still be undefined here. Waiting means _playerTarget() definitely runs.
    const ready = window.customElements && customElements.whenDefined
      ? customElements.whenDefined('video-media')
      : Promise.resolve();

    media._ucPrepared = ready.then(() => {
      // Runs _playerTarget(): wires the play/pause listeners that maintain `playing`, which is
      // what group pausing keys off.
      void media.player;

      /* Then set the two state attributes outright. theme.css keeps the <video> at
         `visibility: hidden` until `loaded` is present, showing the poster <img> instead, and
         the component only sets it as a side effect of its own play path -- the same path that
         does not start this video. Left to chance, the clip plays behind a hidden element or
         does not play at all. Setting them is idempotent and is what the component would do. */
      media.setAttribute('loaded', '');
      media.setAttribute('can-play', '');
    });

    return media._ucPrepared;
  }

  /* Two conditions, both required.

     Visibility alone was wrong: scrolling the page up and down past the gallery started the clip
     every time it came back into view, whatever slide the gallery was actually on. Selection
     alone was wrong too: choosing the slide while the gallery is off-screen would play a video
     nobody can see.

     The two are tracked separately because they change independently -- the observer knows about
     scrolling and nothing else, carousel events know about the slide and nothing else -- and
     whichever moves last calls ucApplySocialState with both.

     Leaving the slide rewinds; scrolling away does not. A clip you scrolled past should carry on
     where it was when you come back, but a slide you left and returned to should start again. */
  function ucApplySocialState(video, { rewind = false } = {}) {
    const media = video.closest('video-media');
    if (!media) return;

    // No observer (or none yet) means visibility is unknown, not false -- do not gate on it.
    const visible = video._ucVisible !== false;

    if (video._ucSelected && visible) {
      ucPrepareSocialMedia(media).then(() => {
        if (!video._ucSelected || video._ucVisible === false) return;
        const playing = video.play();
        if (playing && typeof playing.catch === 'function') playing.catch(() => {});
      });
      return;
    }

    if (!video.paused) video.pause();
    if (rewind && video.currentTime) video.currentTime = 0;
  }

  let socialObserver = null;

  function ucObserveSocialVideos() {
    if (window.IntersectionObserver && !socialObserver) {
      socialObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            video._ucVisible =
              entry.isIntersecting && entry.intersectionRatio >= SOCIAL_VISIBLE_RATIO;
            ucApplySocialState(video);
          });
        },
        { threshold: [0, SOCIAL_VISIBLE_RATIO, 1] }
      );
    }

    document.querySelectorAll('.product-gallery__media--social video-media').forEach((media) => {
      ucPrepareSocialMedia(media);

      const video = media.querySelector('video');
      if (!video || video._ucObserved) return;
      video._ucObserved = true;

      // Seed the selection from the gallery as it stands, so a video that opens on screen plays.
      const carousel = media.closest('media-carousel');
      const slide = media.closest('.product-gallery__media');
      video._ucSelected = !!(carousel && carousel.selectedSlide === slide);

      if (socialObserver) socialObserver.observe(video);
      ucApplySocialState(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ucObserveSocialVideos);
  } else {
    ucObserveSocialVideos();
  }

  // A variant change re-renders the gallery, so the new elements need picking up.
  document.addEventListener('product:rerender', ucObserveSocialVideos);

  function ucSyncSocialSlides(event) {
    const gallery = event.target.closest && event.target.closest('product-gallery');
    if (!gallery) return;

    const selected = (event.detail && event.detail.slide) || event.target.selectedSlide;

    gallery.querySelectorAll('.product-gallery__media--social video-media').forEach((media) => {
      const video = media.querySelector('video');
      if (!video) return;

      const slide = media.closest('.product-gallery__media');
      const nowSelected = slide === selected;
      const wasSelected = video._ucSelected;
      video._ucSelected = nowSelected;

      ucApplySocialState(video, { rewind: wasSelected && !nowSelected });

      if (nowSelected && !wasSelected) {
        ucAfterGalleryResize(event.target, () => ucRevealGalleryDots(slide));
      }
    });
  }

  /* Both events, because they answer different questions: change is "this slide was chosen",
     settle is "the sliding has stopped". Running again on settle also puts the clip back if
     anything paused it during the transition. */
  document.addEventListener('carousel:change', ucSyncSocialSlides);
  document.addEventListener('carousel:settle', ucSyncSocialSlides);

  /* ---------------------------------------------------------------------------------------------
     5c. Resize the gallery with the slide, not after it

     Slides differ in height -- a square photo against a full-width portrait clip, 375 against
     668 on a phone -- and the carousel tracks that with an inline max-height and overflow-y:
     hidden. Get it wrong and the clip is not merely mis-sized, it is CUT OFF: a 668px video
     inside a box still capped at 375px shows its top half and nothing else.

     The theme sets that cap from `_adjustHeight`, bound to carousel:settle, so nothing happens
     until the sliding has finished and the gallery then jumps. It also clears the inline value
     before setting the new one, so the property animates from `none`, which does not animate.

     So it is set here on carousel:change, when the slide is chosen rather than when it lands,
     straight from the old value to the new one. custom.css supplies the transition.

     (This block was deleted once by an edit that replaced the span it sat in, and the clipping
     came straight back. If the clip is ever half a video again, look here first.)
     --------------------------------------------------------------------------------------------- */
  document.addEventListener('carousel:change', (event) => {
    const carousel = event.target;
    if (!carousel.matches || !carousel.matches('media-carousel.product-gallery__media-list')) return;
    if (!carousel.hasAttribute('adaptive-height')) return;

    const slide = (event.detail && event.detail.slide) || carousel.selectedSlide;
    const height = slide && slide.clientHeight;
    if (!height) return;

    carousel.style.maxHeight = height + 'px';
  });

  /* Swiping to the clip brings it to the top of the screen.

     On mobile the clip is full width, so it is about 668px tall on a 375px phone. Landing on it
     halfway down the viewport shows most of a video and none of the page dots, and the customer
     cannot tell whether there is more of it or more of the gallery. Pulled flush to the top, the
     clip occupies from the top down and the dots sit in the space left below.

     Bound to the slide becoming SELECTED, not to page scroll. Moving the page while someone is
     scrolling it is scroll-jacking -- they fight it, and it is horrible on touch. A swipe is a
     deliberate act with an obvious response; scrolling past is not.

     The offset is the sticky header, because "the top of the screen" is the top of the part of
     the screen the page actually gets. */
  /* Swiping to the clip scrolls just far enough to show the page dots.

     On mobile the clip is full width and about 668px tall on a 375px phone, so landing on it
     usually leaves the dots below the fold -- and with them the only sign that there is anything
     either side of this video. The page moves by the smallest amount that brings them back, and
     not a pixel more: an earlier version pulled the slide flush with the top of the screen,
     which moved further and made the jump more noticeable for the same result.

     Nothing happens if the dots are already on screen, and it never scrolls UP -- a customer who
     has deliberately scrolled past the gallery should not be dragged back to it.

     Bound to the slide becoming SELECTED, never to page scroll. Moving the page while someone is
     scrolling it is scroll-jacking; they fight it, and on touch it is horrible. A swipe is a
     deliberate act and can have a deliberate response. */
  const DOTS_REVEAL_PAD = 12;

  function ucGalleryDots(gallery) {
    return Array.from(gallery.querySelectorAll('page-dots')).find(
      (dots) =>
        !dots.classList.contains('product-gallery__thumbnail-list') && dots.offsetParent !== null
    );
  }

  function ucRevealGalleryDots(slide) {
    if (!ucMobileGallery.matches || !slide) return;

    const gallery = slide.closest('product-gallery');
    const dots = gallery && ucGalleryDots(gallery);
    if (!dots) return;

    const below = dots.getBoundingClientRect().bottom + DOTS_REVEAL_PAD - window.innerHeight;
    if (below <= 0) return;

    window.scrollBy({ top: below, behavior: 'smooth' });
  }

  /* One thing moves at a time.

     Arriving at the clip used to animate three things at once -- the slide travelling across,
     the gallery growing from an image's 375px to the clip's 668px, and the page scrolling -- and
     the result read as jank rather than as motion.

     It was also measuring the wrong distance. The dots are below the gallery, so where they end
     up depends on the height the gallery is growing INTO; reading their position while that was
     still animating gave a scroll that was short by however much growing was left.

     So the scroll waits for the resize to finish. transitionend is the real signal; the timeout
     is there because it never fires if the height happens not to change, or if transitions are
     disabled for reduced motion. */
  const RESIZE_SETTLE_MS = 450;

  function ucAfterGalleryResize(carousel, done) {
    let fired = false;

    const finish = () => {
      if (fired) return;
      fired = true;
      carousel.removeEventListener('transitionend', onEnd);
      done();
    };

    const onEnd = (event) => {
      if (event.target === carousel && event.propertyName === 'max-height') finish();
    };

    carousel.addEventListener('transitionend', onEnd);
    setTimeout(finish, RESIZE_SETTLE_MS);
  }

  /* ---------------------------------------------------------------------------------------------
     5b. The thumbnail rail follows the selection by the SHORTEST distance, not by centring

     `align-selected` on the rail makes page-dots centre the selected thumbnail on every change --
     410px of travel, measured, for a hover on the tenth of eleven. Under a cursor that has not
     moved, that drops a different thumbnail beneath the pointer; the browser fires mouseover for
     it, another swap is queued, and the gallery walks through the images by itself. Raising
     HOVER_DELAY only set the pace of that loop.

     The cure is not to stop the rail moving, nor to ignore the hovers, but to stop it moving when
     it has no reason to: a thumbnail you can already see does not need scrolling to, so hovering
     down a visible rail now shifts nothing and there is nothing to cascade from. The rail still
     tracks the selection when it genuinely goes out of view -- a swipe on the main image, a page
     dot, a variant change -- and then travels only far enough to show it.
     --------------------------------------------------------------------------------------------- */
  /* How much clear space the selected thumbnail needs beyond it before the rail is left alone.
     One whole thumbnail, so selecting the last one you can fully see still scrolls -- it brings
     the next along and shows there is more rail to come. At 8px the rail sat still whenever the
     selection was merely visible, which read as broken at the bottom edge.

     Capped at a third of the rail so a short rail cannot demand more headroom than it has. */
  function ucRailPad(rail) {
    const items = rail.children;
    let pitch = 83;

    if (items.length > 1) {
      const measured = items[1].offsetTop - items[0].offsetTop;
      if (measured > 0) pitch = measured;
    } else if (items.length === 1 && items[0].offsetHeight > 0) {
      pitch = items[0].offsetHeight;
    }

    return Math.min(pitch, rail.clientHeight / 3);
  }

  function ucRailFollow(gallery, index) {
    const rail = gallery.querySelector('.product-gallery__thumbnail-list');
    if (!rail) return;

    const thumb = rail.children[index];
    if (!thumb || thumb.hidden) return;

    const RAIL_REVEAL_PAD = ucRailPad(rail);
    const railBox = rail.getBoundingClientRect();
    const thumbBox = thumb.getBoundingClientRect();
    const vertical = rail.scrollHeight - rail.clientHeight > 1;
    const horizontal = rail.scrollWidth - rail.clientWidth > 1;

    if (vertical) {
      let delta = 0;
      if (thumbBox.top < railBox.top + RAIL_REVEAL_PAD) {
        delta = thumbBox.top - railBox.top - RAIL_REVEAL_PAD;
      } else if (thumbBox.bottom > railBox.bottom - RAIL_REVEAL_PAD) {
        delta = thumbBox.bottom - railBox.bottom + RAIL_REVEAL_PAD;
      }
      if (delta) rail.scrollBy({ top: delta, behavior: 'smooth' });
      return;
    }

    if (horizontal) {
      let delta = 0;
      if (thumbBox.left < railBox.left + RAIL_REVEAL_PAD) {
        delta = thumbBox.left - railBox.left - RAIL_REVEAL_PAD;
      } else if (thumbBox.right > railBox.right - RAIL_REVEAL_PAD) {
        delta = thumbBox.right - railBox.right + RAIL_REVEAL_PAD;
      }
      if (delta) rail.scrollBy({ left: delta, behavior: 'smooth' });
    }
  }

  /* Take the attribute off every gallery rail, so page-dots stops centring. It still answers
     carousel:change to move aria-current, which is untouched by this. */
  function ucReleaseRails(root) {
    (root || document)
      .querySelectorAll('product-gallery .product-gallery__thumbnail-list[align-selected]')
      .forEach((rail) => rail.removeAttribute('align-selected'));
  }

  ucReleaseRails();
  document.addEventListener('DOMContentLoaded', () => ucReleaseRails());
  document.addEventListener('product:rerender', () => ucReleaseRails());

  document.addEventListener('carousel:change', (event) => {
    const gallery = event.target.closest && event.target.closest('product-gallery');
    if (!gallery) return;

    const index = event.detail && event.detail.index;
    if (typeof index !== 'number') return;

    ucReleaseRails(gallery);
    ucRailFollow(gallery, index);
  });

  /* ---------------------------------------------------------------------------------------------
     6. Desktop: the vertical thumbnail rail steps one thumbnail per wheel notch

     The rail is a ~600px overflow:auto column (theme.css, tightened in custom.css at 1150px), so
     the browser scrolls it by its own notch distance - about 100px against an 83px thumbnail
     pitch. That lands mid-thumbnail and overshoots, which is what reads as "too quick" once a
     product has more thumbnails than the rail can show.

     Deltas are accumulated rather than scaled so the same handler suits both input devices: a
     mouse notch clears the threshold on its own and steps once, while a trackpad's stream of
     small deltas has to add up first.
     --------------------------------------------------------------------------------------------- */
  const WHEEL_STEP_THRESHOLD = 40;   // accumulated px before the rail moves by one thumbnail
  const WHEEL_IDLE_RESET = 250;      // ms of quiet after which a part-finished gesture is dropped

  document.addEventListener(
    'wheel',
    (event) => {
      if (event.ctrlKey || event.deltaY === 0) return;   // ctrl+wheel is browser zoom

      const rail =
        event.target.closest && event.target.closest('.product-gallery__thumbnail-list');
      if (!rail || !rail.closest('.product-gallery--desktop-thumbnails-left')) return;

      // Below 1150px the rail is the horizontal strip, which has no vertical overflow to step.
      const maxScroll = rail.scrollHeight - rail.clientHeight;
      if (maxScroll <= 1) return;

      const direction = event.deltaY > 0 ? 1 : -1;

      // Let the page have the wheel at either end, so the rail never traps the scroll.
      const atEnd = direction > 0 ? rail.scrollTop >= maxScroll - 1 : rail.scrollTop <= 1;
      if (atEnd) {
        rail._ucWheelAccum = 0;
        return;
      }

      event.preventDefault();

      const now = Date.now();
      const stale = now - (rail._ucWheelAt || 0) > WHEEL_IDLE_RESET;
      const reversed = Math.sign(rail._ucWheelAccum || 0) !== 0 &&
        Math.sign(rail._ucWheelAccum) !== direction;
      rail._ucWheelAccum = stale || reversed ? 0 : rail._ucWheelAccum || 0;
      rail._ucWheelAt = now;

      rail._ucWheelAccum += ucNormalizeWheel(event, rail);
      if (Math.abs(rail._ucWheelAccum) < WHEEL_STEP_THRESHOLD) return;

      // Spend the whole accumulator on one step. Carrying the remainder would make every other
      // notch travel two thumbnails, which is the overshoot this is here to remove.
      rail._ucWheelAccum = 0;

      // Keep stepping from the position the last notch aimed at, not from wherever the smooth
      // scroll happens to be mid-flight, or fast notches lose ground against their own animation.
      // Only within one continuous gesture, though: `stale` also covers the rail having been moved
      // by something else since - its scrollbar, or align-selected pulling a clicked thumbnail into
      // view - after which a remembered target would step from a position the rail has left.
      const chaining = !stale && rail._ucWheelTarget != null &&
        Math.abs(rail._ucWheelTarget - rail.scrollTop) < rail.clientHeight;
      const from = chaining ? rail._ucWheelTarget : rail.scrollTop;

      const target = Math.max(0, Math.min(maxScroll, from + direction * ucThumbnailPitch(rail)));
      rail._ucWheelTarget = target;
      rail.scrollTo({ top: target, behavior: 'smooth' });
    },
    { passive: false }
  );

  /* deltaMode 1 is lines and 2 is pages; Firefox uses lines for a mouse wheel. */
  function ucNormalizeWheel(event, rail) {
    if (event.deltaMode === 1) return event.deltaY * 16;
    if (event.deltaMode === 2) return event.deltaY * rail.clientHeight;
    return event.deltaY;
  }

  /* Measured, not assumed: the rail's gap and thumbnail size both change with the breakpoint. */
  function ucThumbnailPitch(rail) {
    const items = rail.children;
    if (items.length > 1) {
      const pitch = items[1].offsetTop - items[0].offsetTop;
      if (pitch > 0) return pitch;
    }
    if (items.length > 0 && items[0].offsetHeight > 0) return items[0].offsetHeight + 8;
    return 83;
  }

  /* ---------------------------------------------------------------------------------------------
     7. Mobile: a swipe advances exactly one image

     custom.css gives the media list `touch-action: pan-y pinch-zoom` below 1000px, which takes
     horizontal panning away from the browser — without that the strip follows the finger and no
     amount of JS can stop it. That computed value is also the switch this handler reads, so the
     breakpoint is stated once, in the stylesheet.

     The jump itself is the carousel's own `select(index, { animate: false })`, which scrolls with
     `behavior: 'auto'`. Going through select() rather than setting scrollLeft keeps the page dots,
     the thumbnail rail and the carousel:select listeners in step.

     Tapping a page dot is left to the theme, which already animates it the same way.
     --------------------------------------------------------------------------------------------- */
  const SWIPE_MIN_PX = 40;    // horizontal travel before a drag counts as a swipe
  const SWIPE_SLOPE = 1.2;    // ...and by how much it must beat the vertical travel, so that a
                              // diagonal page scroll does not also change the image
  const WHEEL_SWIPE_PX = 50;  // accumulated horizontal wheel travel before it steps one image

  /* The single gate for "this is the jumping gallery". It used to be the computed touch-action,
     which read nicely but made every handler depend on a stylesheet having loaded and applied -
     if that ever failed the gallery reverted to sliding with nothing to say why. Same 999px
     breakpoint the CSS uses. */
  const ucMobileGallery = window.matchMedia('(max-width: 999px)');
  const ucGalleryJumps = () => ucMobileGallery.matches;

  let swipeStart = null;

  document.addEventListener(
    'touchstart',
    (event) => {
      swipeStart = null;
      if (event.touches.length !== 1) return;

      if (!ucGalleryJumps()) return;

      const carousel =
        event.target.closest && event.target.closest('media-carousel.product-gallery__media-list');
      if (!carousel) return;

      swipeStart = { carousel, x: event.touches[0].clientX, y: event.touches[0].clientY };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      const start = swipeStart;
      swipeStart = null;

      const touch = event.changedTouches && event.changedTouches[0];
      if (!start || !touch) return;

      const dx = touch.clientX - start.x;
      const dy = touch.clientY - start.y;
      if (Math.abs(dx) < SWIPE_MIN_PX || Math.abs(dx) < Math.abs(dy) * SWIPE_SLOPE) return;

      // Swiping right-to-left advances, the direction the strip used to travel.
      ucStepSlide(start.carousel, dx < 0 ? 1 : -1);
    },
    { passive: true }
  );

  /* A two-finger horizontal swipe on a trackpad is a `wheel` event carrying deltaX, NOT a touch,
     so `touch-action` does not govern it and the touch handler above never sees it. Left alone,
     it scrolls the carousel natively - which is the sliding this whole section exists to remove,
     still happening for anyone checking the mobile layout on a laptop.

     Only a predominantly horizontal gesture is taken; a vertical or diagonal one is left to
     scroll the page. Deltas accumulate, because a trackpad emits a stream of small ones. */
  document.addEventListener(
    'wheel',
    (event) => {
      if (event.ctrlKey || !ucGalleryJumps()) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;

      const carousel =
        event.target.closest && event.target.closest('media-carousel.product-gallery__media-list');
      if (!carousel) return;

      event.preventDefault();

      const now = Date.now();
      const direction = event.deltaX > 0 ? 1 : -1;
      const stale = now - (carousel._ucWheelAt || 0) > WHEEL_IDLE_RESET;
      const reversed = Math.sign(carousel._ucWheelAccum || 0) !== 0 &&
        Math.sign(carousel._ucWheelAccum) !== direction;
      carousel._ucWheelAccum = stale || reversed ? 0 : carousel._ucWheelAccum || 0;
      carousel._ucWheelAt = now;

      carousel._ucWheelAccum += event.deltaX;
      if (Math.abs(carousel._ucWheelAccum) < WHEEL_SWIPE_PX) return;

      carousel._ucWheelAccum = 0;
      ucStepSlide(carousel, direction);
    },
    { passive: false }
  );

  /* ---------------------------------------------------------------------------------------------
     Re-snap the gallery onto its selected slide

     The carousel scrolls to an ABSOLUTE position -- `itemOffset * index` -- and then never checks
     it again. Anything that changes slide width after that position was computed leaves the strip
     standing a few pixels off, with a sliver of the neighbouring image down one edge, and nothing
     puts it right until the next select(). Candidates on this page: the initial select() in
     connectedCallback running before images and fonts have settled, the cookie banner, a device
     rotation, and any fractional slide width (a 427.5px pitch read through the theme's rounded
     offsetLeft as 427 loses half a pixel PER SLIDE, so the error grows with the index).

     Rather than chase each cause, measure and correct: the gap between the selected slide's edge
     and the carousel's edge is the error, whatever produced it, and adding it to scrollLeft
     cancels it exactly. Cheap, idempotent, and it cannot drift because it is relative.

     Deliberately NOT bound to scroll -- only to the moments when the layout has changed
     underneath a position that was already chosen. Fighting a scroll in progress would trap the
     gallery on one image. */
  function ucResnapGallery(carousel) {
    if (!carousel || !carousel.items || carousel.items.length < 2) return;
    if (carousel._hasPendingProgrammaticScroll) return;

    const selected = carousel.items[carousel.selectedIndex];
    if (!selected || selected.hidden) return;

    const delta = selected.getBoundingClientRect().left - carousel.getBoundingClientRect().left;
    if (!delta || Math.abs(delta) < 0.5 || Math.abs(delta) > carousel.clientWidth) return;

    carousel.scrollLeft += delta;
  }

  function ucResnapAll() {
    document.querySelectorAll('media-carousel.product-gallery__media-list').forEach(ucResnapGallery);
  }

  let resnapTimer = null;
  const ucResnapSoon = () => {
    clearTimeout(resnapTimer);
    resnapTimer = setTimeout(ucResnapAll, 150);
  };

  window.addEventListener('load', ucResnapSoon);
  window.addEventListener('resize', ucResnapSoon);
  window.addEventListener('orientationchange', ucResnapSoon);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ucResnapSoon);

  /* Catches what the events above miss: images finishing, the cookie banner closing, a variant
     change re-rendering the gallery. Width only -- `adaptive-height` changes the height on every
     slide change, and re-snapping on that would be constant pointless work. */
  if (window.ResizeObserver) {
    const seen = new WeakMap();
    const observer = new ResizeObserver((entries) => {
      let changed = false;
      entries.forEach((entry) => {
        const width = entry.contentRect.width;
        if (seen.get(entry.target) !== width) { seen.set(entry.target, width); changed = true; }
      });
      if (changed) ucResnapSoon();
    });

    const observeGalleries = () =>
      document.querySelectorAll('media-carousel.product-gallery__media-list')
        .forEach((el) => observer.observe(el));

    observeGalleries();
    document.addEventListener('product:rerender', observeGalleries);
  }

  /* ---------------------------------------------------------------------------------------------
     8. Carousel corrections applied to the class itself

     Two shadowed getters on media-carousel. Both are one-liners the theme gets slightly wrong,
     and patching the prototype rather than each element covers galleries that are re-rendered
     later: a variant change, quick view, the drawer. Guarded by customElements.whenDefined, so
     script order does not matter and a future rename degrades to a no-op.
     --------------------------------------------------------------------------------------------- */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-carousel').then(() => {
      const carousel = customElements.get('media-carousel');
      const proto = carousel && carousel.prototype;
      if (!proto || proto._ucPatched) return;
      proto._ucPatched = true;

      /* `loop` -- clicking the right or left half of the main image on a fine pointer calls
         next()/previous() (theme.js `_onGalleryClick`, mirrored in 3 above for the review slide).
         Those read nextSlide/previousSlide, which ALREADY carry a wrapping branch; the theme just
         hard-codes `get loop() { return false }`, so the branch never runs and the click stopped
         dead on the last image. `loop` is read in those two getters and nowhere else. */
      Object.defineProperty(proto, 'loop', { get: () => true, configurable: true });

      /* `itemOffset` -- the slide pitch, which _transitionTo multiplies by the index to get an
         absolute scroll position. The theme measures it with offsetLeft, which is ROUNDED TO
         WHOLE PIXELS, so a true pitch of 427.48px is taken as 427 and the missing half-pixel is
         multiplied too: by the tenth image the strip stands ~4px short and a sliver of the
         previous image shows down the left edge.

         Invisible until now only because slides were 84vw and a slice of the neighbour was on
         display deliberately. Going full width is what exposed it.

         It needs a fractional slide width to bite, which is why it reproduces under a scaled
         viewport -- DevTools "Fit to window", browser zoom, and plenty of real devices -- and not
         at a clean 425px, where the pitch is exactly 427 and both readings agree.

         getBoundingClientRect() reports fractions. The difference between two slides cancels out
         the scroll position, so this is safe to read at any time. */
      Object.defineProperty(proto, 'itemOffset', {
        get() {
          const visible = this.visibleItems;
          if (visible.length < 2) return 0;
          return visible[1].getBoundingClientRect().left - visible[0].getBoundingClientRect().left;
        },
        configurable: true
      });

      /* The wrap step is not animated. Ordinary steps slide by one image, but sliding from the
         last image to the first would smooth-scroll the whole strip, and next()/previous()
         already take an animate flag. */
      ['next', 'previous'].forEach((name) => {
        const original = proto[name];
        if (typeof original !== 'function') return;

        proto[name] = function (animate = true) {
          const total = this.visibleItems.length;
          const current = this.selectedIndexAmongVisible;
          const wrapping =
            total > 1 && (name === 'next' ? current === total - 1 : current === 0);

          return original.call(this, wrapping ? false : animate);
        };
      });
    });
  }

  /* Step by one VISIBLE slide, wrapping at both ends: swiping on past the last image returns to
     the first, and back past the first lands on the last. Walking the VISIBLE list is what makes
     the wrap land correctly - a variant change hides the media belonging to other variants, so
     stepping through `items` would both land on a hidden slide (select() resolves such an index
     to -1 and silently does nothing) and wrap at the wrong end.

     The wheel-driven thumbnail rail deliberately does NOT wrap: it releases the wheel to the page
     at either end, which is the only way to scroll the page onward with the cursor over it. */
  function ucStepSlide(carousel, direction) {
    const visible = carousel.visibleItems;
    if (!visible || visible.length < 2) return;

    const current = visible.indexOf(carousel.items[carousel.selectedIndex]);
    if (current === -1) return;

    const next = (current + direction + visible.length) % visible.length;

    // Ordinary steps slide. The wrap does not: last-to-first would smooth-scroll the whole strip.
    const wrapping = direction > 0 ? next === 0 : current === 0;

    carousel.select(carousel.items.indexOf(visible[next]), { animate: !wrapping });
  }
})();

/* Auto-Gift Engine
 *
 * Adds and removes gift lines to match the rules in window.UC_GIFT_RULES
 * (see snippets/gift-rules.liquid). Lines we own are tagged with the
 * `_Gifted` line-item property, whose value is the rule name — that
 * property is the ONLY thing marking a line as ours, so we never touch a
 * copy of the same product the customer paid for.
 *
 * Lives here, not in theme.js: an Impact upgrade replaces theme.js wholesale
 * (7.2.0 was a re-application, not a merge), so store logic put there is
 * lost at the next version bump.
 */
(() => {
  const PROPERTY = '_Gifted';
  const OWNER_PROPERTY = '_GiftedBy';
  const OWNER = 'uc-auto-gift';
  const MAX_PASSES = 5;
  const STATE_KEY = 'uc:gift:state';
  // Marks the engine's OWN cart writes so the network watcher at the foot of
  // this file can ignore them. Without it the watcher sees our add,
  // reconciles, and adds again - the very loop desired===actual prevents.
  const OWN_HEADER = 'X-UC-Gift-Engine';

  // Product types that do not count toward a rule's threshold. Matched
  // case-insensitively because Shopify product types are free text.
  const EXCLUDED_TYPES = new Set([
    'bondage rope',
    'wax play candles',
    'gags',
    'accessories',
    'accessories & upgrades',
    'lubricants',
    'gift cards',
    'customisation',
    'free gift',
    'giftbox_ghost_product',
    'options_price',
  ]);

  const rules = () => window.UC_GIFT_RULES || [];
  const norm = (s) => (s || '').trim().toLowerCase();

  /* ── Ownership ────────────────────────────────────────────────────────
   * `_Gifted: <rule name>` is a convention we SHARE with the EasyGift app
   * (cdn.506.io), which is still installed and manages the same Mystery
   * Dildo product. So the presence of `_Gifted` alone does NOT mean we put
   * the line there, and acting as though it did is destructive: the orphan
   * sweep below would delete EasyGift's line (its rule name is not in our
   * rule list), EasyGift would re-add it, and the two would fight — both
   * POSTing to /cart concurrently, which surfaces as a cart error and a
   * gift that vanishes on page load.
   *
   * `_GiftedBy` is our own marker. Ownership requires it, so we can only
   * ever remove or re-quantify lines this engine created. Anything else
   * with `_Gifted` is another system's business and is left alone.
   *
   * Both properties are `_`-prefixed, so neither renders customer-facing
   * (see the property loop in snippets/line-item.liquid) while both stay
   * visible on the order in admin.
   */
  const giftedName = (line) => line.properties?.[PROPERTY] || null;
  const isGifted = (line) => Boolean(giftedName(line));       // ANY system's gift
  const ruleNameOf = (line) =>                                 // ours only
    line.properties?.[OWNER_PROPERTY] === OWNER ? giftedName(line) : null;

  /* ── Threshold basis ──────────────────────────────────────────────────
   * A line counts unless its type is excluded OR we added it ourselves.
   * The self-check is load-bearing independently of EXCLUDED_TYPES: a gift
   * whose product_type is not on the list would otherwise inflate the very
   * subtotal that justified it, and could self-promote the cart into a
   * higher tier that then justifies a second gift. A gift must never help
   * pay for itself.
   *
   * final_line_price (not original_line_price) so a discount code that
   * drops the customer under the threshold correctly retracts the gift.
   * All cart.js money values are integer minor units (pence).
   */
  /* `gift_card` is checked separately from EXCLUDED_TYPES because the type
   * string is not reliable for this: Sinnovator's "Sinnovator Gift Card" has
   * a BLANK product_type, so the 'gift cards' entry never matches it and a
   * £50 gift card would earn a free gift. cart.js exposes an authoritative
   * per-line boolean, so use that and let the type entry cover the rest.
   */
  const counts = (line, upgradeIds) =>
    !isGifted(line) &&
    !line.gift_card &&
    !upgradeIds.has(line.product_id) &&
    !EXCLUDED_TYPES.has(norm(line.product_type));

  const eligibleSubtotal = (cart, upgradeIds) =>
    cart.items.reduce((sum, line) => (counts(line, upgradeIds) ? sum + line.final_line_price : sum), 0);

  const qualifies = (rule, subtotal) =>
    subtotal >= (rule.min_subtotal ?? 0) &&
    (rule.max_subtotal == null || subtotal < rule.max_subtotal);

  /* ── Upgrade products ─────────────────────────────────────────────────
   * The Mystery Dildo size-upgrade is a PAID product priced on the
   * assumption that the customer already earned the free mystery — it
   * upgrades the gift rather than being bought on its own merits. That
   * gives it three linked behaviours, all from one list:
   *
   *   1. It SUPPRESSES the gift. The larger mystery is what ships, so the
   *      free X-Small must go. (The Mechanic task
   *      `remove-free-mystery-dildo-on-upgrade` also does this, but only on
   *      orders/create — after checkout, by order edit. Doing it in the cart
   *      means the customer never sees a gift that later vanishes from their
   *      order, and leaves Mechanic as the backstop.)
   *
   *   2. It does NOT COUNT toward the threshold. An upgrade must not help
   *      pay for the eligibility that justifies it, for the same reason a
   *      gift must not — otherwise the upgrade alone can self-qualify.
   *
   *   3. It is REMOVED when the spend condition fails. Without this the
   *      customer adds a product, takes the gift, buys the upgrade, then
   *      deletes the original product and keeps a heavily discounted
   *      mystery they never qualified for.
   *
   * Note (3) keys on the SPEND test alone, never on `earned` — `earned`
   * already accounts for (1), so using it here would be circular: the
   * upgrade would suppress the gift, that would read as "not earned", and
   * the upgrade would delete itself the moment it was added.
   */
  const upgradeIdsOf = (rule) => rule.upgrade_product_ids || [];

  /* ── Per-rule session state ───────────────────────────────────────────
   * { "<rule name>": { added: bool, dismissedAt: pence|null } }
   *
   * `added` records that WE successfully put this gift in the cart. If it
   * later disappears while the cart still qualifies, the customer deleted
   * it — which is how a manual removal is detected without hanging any hook
   * off the cart markup. Re-adding it immediately would mean they could
   * never get rid of it.
   *
   * `dismissedAt` is the eligible subtotal at the moment they deleted it.
   * The gift is re-offered as soon as that subtotal INCREASES: adding
   * another product is a fresh purchase decision. Removing a product is
   * not, so a shrinking cart stays dismissed — but the recorded figure
   * follows it down, so any later increase still re-offers. Dropping below
   * the threshold clears the dismissal outright.
   */
  const loadState = () => {
    try { return JSON.parse(sessionStorage.getItem(STATE_KEY) || '{}'); }
    catch { return {}; }
  };
  const saveState = (state) => {
    try { sessionStorage.setItem(STATE_KEY, JSON.stringify(state)); }
    catch { /* private mode — engine still works, dismissals just won't persist */ }
  };

  /* ── Serialized cart writes ───────────────────────────────────────────
   * Concurrent /cart/*.js calls against one session interleave, and ANY
   * mutation invalidates every line key captured before it. So writes are
   * strictly ordered and keys are always re-read from a fresh cart.
   */
  let chain = Promise.resolve();
  function serial(fn) {
    const running = chain.then(fn, fn);
    chain = running.catch(() => {});
    return running;
  }

  async function addGift(rule) {
    const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // needed for Shopify to check inventory
        [OWN_HEADER]: '1',
      },
      body: JSON.stringify({
        items: [{
          id: rule.variant_id,
          quantity: rule.quantity || 1,
          properties: { [PROPERTY]: rule.name, [OWNER_PROPERTY]: OWNER },
        }],
      }),
    });
    if (!res.ok) {
      // Almost always out of stock. Never retry in-loop and never block the
      // customer — the cart is still valid without the gift.
      console.warn(`[gift] could not add "${rule.name}":`, (await res.json())?.description);
      return false;
    }
    return true;
  }

  async function setLineQuantity(lineKey, quantity) {
    const res = await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', [OWN_HEADER]: '1' },
      body: JSON.stringify({ id: lineKey, quantity }),
    });
    if (!res.ok) {
      console.warn('[gift] could not change line', lineKey, (await res.json())?.description);
      return false;
    }
    return true;
  }

  /* ── Reconcile ────────────────────────────────────────────────────────
   * Idempotent state machine: compute the gift lines the cart SHOULD have,
   * diff against what it HAS, apply the difference. When desired === actual
   * it does nothing — that no-op is what stops cart:change → add →
   * cart:change from looping. MAX_PASSES is a backstop so a rule bug cannot
   * spin the browser or hammer Shopify.
   */
  async function reconcile(pass = 0) {
    if (pass >= MAX_PASSES) {
      console.warn('[gift] pass cap reached, giving up');
      return;
    }

    const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    const state = loadState();
    const active = rules();
    const upgradeIds = new Set(active.flatMap(upgradeIdsOf));
    const subtotal = eligibleSubtotal(cart, upgradeIds);
    const known = new Set(active.map((r) => r.name));
    let mutated = false;

    // 1. Drop orphans: gift lines whose rule was renamed or deleted. Left
    //    alone they sit in the cart forever, at whatever price the discount
    //    no longer zeroes.
    for (const line of cart.items) {
      const name = ruleNameOf(line);
      if (name && !known.has(name)) {
        if (await setLineQuantity(line.key, 0)) mutated = true;
      }
    }

    /* 2. Customer-added gift lines.
     *    The gift product is unlisted (seo.hidden), not unpublished — so it
     *    is still reachable by direct URL and by /cart/<variant>:1 permalink,
     *    and nothing server-side stops someone adding a £0 product by hand.
     *    This is EasyGift's `preventAddedItemPurchase`, which is currently
     *    OFF on the UC rule, so the hole is open today.
     *
     *    The three-way test matters for coexistence: OUR line carries
     *    _GiftedBy, EasyGift's carries _Gifted alone, and a hand-added line
     *    carries neither. Only the last is removed — an unclaimed line is
     *    the only one that can be a manual add. Per-rule opt-out via
     *    prevent_manual_add: false, in case it ever fights another app.
     */
    const guarded = new Map(
      active.filter((r) => r.prevent_manual_add !== false).map((r) => [r.variant_id, r]),
    );
    for (const line of cart.items) {
      const guard = guarded.get(line.variant_id);
      if (!guard) continue;
      if (ruleNameOf(line)) continue;   // ours — the per-rule loop below owns it
      // A line carrying _Gifted but not _GiftedBy belongs to another gift
      // system. While EasyGift is installed that must be left alone. Once it
      // is uninstalled its lines are stranded in live carts — nothing will
      // ever clean them — so `exclusive: true` claims the variant outright
      // and sweeps them too. Flip it in gift-rules.liquid at uninstall.
      if (isGifted(line) && !guard.exclusive) continue;
      if (await setLineQuantity(line.key, 0)) mutated = true;
    }

    for (const rule of active) {
      const st = state[rule.name] || (state[rule.name] = { added: false, dismissedAt: null });
      const upgrades = upgradeIdsOf(rule);
      const meetsSpend = qualifies(rule, subtotal);

      /* Upgrade lines depend on the spend condition alone (see (3) above),
       * and are capped at the number of gifts the rule actually grants — an
       * upgrade upgrades THE GIFT, so one entitlement supports one upgrade.
       * Nothing else caps it: the Mechanic task pointedly never touches the
       * upgrade product ("a paid item can't be deleted"), so without this a
       * customer can hold 10 heavily discounted mysteries behind a single
       * entitlement. Changing an upgrade line never moves `subtotal` —
       * upgrades are excluded from it — so this cannot oscillate.
       */
      const upgradeLines = upgrades.length
        ? cart.items.filter((l) => upgrades.includes(l.product_id))
        : [];
      if (upgradeLines.length) {
        /* When the customer switches size — cart holds "X-Small > Small",
         * they add "X-Small > Medium" — the size they just chose must be the
         * one that survives the cap. cart.js line ORDER cannot decide that:
         * Shopify does not guarantee new lines are appended last, and reading
         * it as recency kept the OLD size and deleted the one they had just
         * picked, so switching size looked broken.
         *
         * Instead, remember which upgrade line keys survived the previous
         * reconcile. A key we have not seen before is, by definition, the one
         * the customer just added. Line keys are `variant:hash-of-properties`
         * and stable for a given variant + properties, so this is exact
         * rather than positional. Falls back to array order only on a fresh
         * session, where nothing has been seen yet.
         */
        const seen = new Set(st.upgradeKeys || []);
        const ordered = [
          ...upgradeLines.filter((l) => !seen.has(l.key)),
          ...upgradeLines.filter((l) => seen.has(l.key)),
        ];
        let remaining = meetsSpend ? (rule.quantity || 1) : 0;
        const survivors = [];
        for (const line of ordered) {
          const keep = Math.min(line.quantity, remaining);
          remaining -= keep;
          if (keep !== line.quantity && await setLineQuantity(line.key, keep)) mutated = true;
          if (keep > 0) survivors.push(line.key);
        }
        st.upgradeKeys = survivors;
      } else {
        st.upgradeKeys = [];
      }

      // A suppressed rule is treated exactly as an unqualified one, so the
      // retract-and-reset path below is shared: adding the size upgrade
      // removes the gift, and removing the upgrade offers it again.
      const hasUpgrade = cart.items.some((l) => upgrades.includes(l.product_id));
      const earned = meetsSpend && !hasUpgrade;

      // Rule lapsed — full reset, so re-crossing the threshold offers afresh.
      if (!earned) {
        st.added = false;
        st.dismissedAt = null;
      } else if (st.dismissedAt != null) {
        if (subtotal > st.dismissedAt) st.dismissedAt = null;          // they added something
        else if (subtotal < st.dismissedAt) st.dismissedAt = subtotal; // follow the cart down
      }

      const ours = cart.items.filter((l) => ruleNameOf(l) === rule.name);

      // 3. Remove gift lines on the wrong variant (rule repointed at a new
      //    product) before counting quantity, or the diff below sees the
      //    right count on the wrong item and no-ops.
      const stale = ours.filter((l) => l.variant_id !== rule.variant_id);
      for (const line of stale) {
        if (await setLineQuantity(line.key, 0)) mutated = true;
      }

      const current = ours.filter((l) => l.variant_id === rule.variant_id);
      const actual = current.reduce((n, l) => n + l.quantity, 0);

      // 4. Manual deletion: we put it there, it qualifies, and it's gone.
      //    Record the dismissal rather than silently re-adding it.
      //    Clearing `added` here consumes the signal — leave it set and the
      //    next subtotal increase clears dismissedAt only for this same check
      //    to re-dismiss it on the spot, and the gift can never come back.
      if (earned && st.added && actual === 0 && st.dismissedAt == null) {
        st.dismissedAt = subtotal;
        st.added = false;
      }

      const desired = earned && st.dismissedAt == null ? (rule.quantity || 1) : 0;

      if (desired === actual && stale.length === 0) continue; // ← the loop breaker

      if (desired === 0) {
        // 5. Conditions no longer met (or dismissed) — retract every line.
        for (const line of current) {
          if (await setLineQuantity(line.key, 0)) mutated = true;
        }
        st.added = false;
      } else if (actual === 0) {
        if (await addGift(rule)) {
          st.added = true;
          mutated = true;
        }
      } else {
        // 6. Collapse to a single line at exactly the rule quantity. This is
        //    what stops the customer bumping the free item to qty 5 with the
        //    stepper — custom.css hides that control on gift lines, but the
        //    cart is the only authority, so it is re-clamped here regardless.
        const [keep, ...extra] = current;
        for (const line of extra) {
          if (await setLineQuantity(line.key, 0)) mutated = true;
        }
        if (keep.quantity !== desired && await setLineQuantity(keep.key, desired)) mutated = true;
        st.added = true;
      }
    }

    saveState(state);

    if (mutated) {
      // Re-run against the new cart: removing an ORPHAN changes the eligible
      // subtotal, and a tiered rule set may need a second pass to settle.
      await reconcile(pass + 1);

      /* Only then repaint, and only once.
       *
       * Drawer/popover: the sections bundled into the /cart/add.js response
       * were rendered BEFORE we touched the cart, so cart:change alone paints
       * a drawer with no gift in it. cart:refresh is the only full re-render.
       *
       * Cart PAGE: cart:refresh re-renders the drawer, not the page, so the
       * retracted gift would sit there looking present until the next load.
       * The theme has the same problem with its own line-item edits and
       * solves it by reloading (see LineItemQuantity._changeLineItemQuantity,
       * which reloads instead of dispatching cart:change when pageType is
       * 'cart' — that is also why our cart:change listener never fires here).
       * Reloading cannot loop: reconcile is idempotent, so the next pass
       * finds desired === actual and never sets mutated.
       */
      if (pass === 0) {
        if (window.themeVariables?.settings?.pageType === 'cart') {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      }
    }
  }

  /* Reconcile work outstanding right now: a pass running, or a debounced one
   * about to start. The checkout guard at the foot of this file waits on it. */
  let inFlight = 0;
  let debounceArmed = false;
  const isBusy = () => inFlight > 0 || debounceArmed;

  const run = () => {
    inFlight++;
    return serial(() => reconcile().catch((e) => console.warn('[gift]', e)))
      .finally(() => { inFlight--; });
  };

  /* ── Triggers ─────────────────────────────────────────────────────────
   * Our own fetches never dispatch cart:change, so reconcile cannot
   * re-trigger itself — settling is handled by the recursion above. The
   * theme dispatches cart:change on documentElement for both adds and
   * quantity edits, and it bubbles to this listener on document.
   */
  document.addEventListener('cart:change', run);

  /* -- Cart writes made by code that does not announce them --------------
   * cart:change is a THEME convention; nothing obliges an app to honour it.
   * Live Product Options (Cloudlift) POSTs /cart/add.js itself and dispatches
   * only its own cloudlift.cart / cloudlift.ajax (both bubbles: false), lpo
   * and options:* events - verified against app-options 0.15.73, which holds
   * ZERO occurrences of 'cart:change' (bundle kept at
   * uc-options-engine/vendor-backup/). On an LPO store the gift is therefore
   * added only when the customer happens to load a full page after
   * configuring a product, and that is most of the attach-rate gap: it is why
   * Sinnovator still misses, and why UC's misses stop at the 2026-09-07
   * cutover to uc-options, which does dispatch cart:change.
   *
   * So watch the NETWORK rather than the event. Any successful cart write
   * reconciles, whoever made it - which also covers whatever replaces LPO.
   * Our own writes carry OWN_HEADER and are skipped, or this recurses.
   */
  const CART_WRITE = new RegExp('/cart/(add|change|update|clear)([.]js)?$');

  const isCartWrite = (url) => {
    try { return CART_WRITE.test(new URL(url, window.location.origin).pathname); }
    catch { return false; }
  };

  // Coalesce: a theme add fires cart:change AND this, and a cart-page bulk
  // edit fires several writes in a row. reconcile is idempotent, so the extra
  // passes would be harmless - just wasteful.
  let debounceTimer;
  const runSoon = () => {
    clearTimeout(debounceTimer);
    // The debounce window counts as busy: nothing is in flight yet, but a
    // reconcile is imminent and checking out now would still lose the gift.
    debounceArmed = true;
    debounceTimer = setTimeout(() => { debounceArmed = false; run(); }, 50);
  };

  const nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      let own = false;
      let url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
        const src = (init && init.headers) || (typeof input === 'object' && input && input.headers);
        if (src) own = new Headers(src).has(OWN_HEADER);
      } catch { /* exotic input - treat as third-party and let it reconcile */ }
      const res = nativeFetch.apply(this, arguments);
      if (!own && url && isCartWrite(url)) {
        Promise.resolve(res).then((r) => { if (r && r.ok) runSoon(); }).catch(() => {});
      }
      return res;
    };
  }

  /* Shopify's own cart JS and a number of apps still use XHR. */
  const nativeOpen = XMLHttpRequest.prototype.open;
  const nativeSetHeader = XMLHttpRequest.prototype.setRequestHeader;
  const nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._ucCartWrite = /post/i.test(method || '') && isCartWrite(url || '');
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.setRequestHeader = function (name) {
    if (String(name).toLowerCase() === OWN_HEADER.toLowerCase()) this._ucOwn = true;
    return nativeSetHeader.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._ucCartWrite && !this._ucOwn) {
      this.addEventListener('load', () => {
        if (this.status >= 200 && this.status < 300) runSoon();
      });
    }
    return nativeSend.apply(this, arguments);
  };

  // Catch carts mutated elsewhere — another tab, an app, returning from
  // checkout. Skip the request entirely when the cart is visibly empty.
  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('cart-count')?.textContent.trim() === '0') return;
    run();
  });
  window.addEventListener('pageshow', (e) => { if (e.persisted) run(); });

  /* -- Do not let the customer check out mid-reconcile -------------------
   * Adding a product and clicking Checkout straight away is a real race: a
   * reconcile is a 50ms debounce plus two or three round trips, and nothing
   * in the theme waits for it. The customer reaches checkout with no gift,
   * and the order lands as a miss indistinguishable from one where the
   * engine never ran at all.
   *
   * Both the drawer (sections/cart-drawer.liquid) and the cart page
   * (sections/main-cart.liquid) render the same control: a submit button
   * named 'checkout' inside a form POSTing to /cart. Intercept in the
   * CAPTURE phase so we act before the theme, then replay the original
   * action once idle - replays are marked so the guard lets them through.
   *
   * The wait is capped. A hung request must never strand somebody on the
   * checkout button: a missing gift is far cheaper than a lost order.
   *
   * NOT covered: the wallet buttons from
   * content_for_additional_checkout_buttons (Shop Pay, PayPal). They render
   * in cross-origin iframes and cannot be intercepted from here, so they
   * stay racy. Only a server-side backstop could close those.
   */
  const CHECKOUT_WAIT_MS = 3000;
  const replaying = new WeakSet();

  async function settle() {
    const deadline = Date.now() + CHECKOUT_WAIT_MS;
    /* Poll on a REAL timer. Awaiting the write chain directly spins on an
     * already-resolved promise and yields only to the microtask queue, which
     * starves macrotasks: timers stop firing, the debounced pass never runs,
     * and the tab freezes for the whole cap. 25ms is imperceptible against a
     * checkout navigation. */
    while (isBusy() && Date.now() < deadline) {
      await new Promise((r) => setTimeout(r, 25));
    }
  }

  const isCheckoutControl = (el) =>
    Boolean(el) && el.name === 'checkout' &&
    (el.tagName === 'BUTTON' || el.tagName === 'INPUT');

  document.addEventListener('click', (event) => {
    const el = event.target && event.target.closest && event.target.closest('[name="checkout"]');
    if (!isCheckoutControl(el)) return;
    if (replaying.has(el)) { replaying.delete(el); return; }
    if (!isBusy()) return;
    event.preventDefault();
    event.stopPropagation();
    el.setAttribute('aria-busy', 'true');
    settle().then(() => {
      el.removeAttribute('aria-busy');
      replaying.add(el);
      el.click();
    });
  }, true);

  /* Submitting with the keyboard never fires a click on the button. */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    const submitter = event.submitter;
    if (!isCheckoutControl(submitter)) return;
    if (replaying.has(form)) { replaying.delete(form); return; }
    if (!isBusy()) return;
    event.preventDefault();
    event.stopPropagation();
    settle().then(() => {
      replaying.add(form);
      if (form.requestSubmit) form.requestSubmit(submitter);
      else form.submit();
    });
  }, true);
})();

/* ==========================================================================
   CART DRAWER — "You may also like" scrolls ONE product per wheel step
   --------------------------------------------------------------------------
   Desktop only (700px+). CSS scroll-snap alone does not do this: a Windows
   wheel notch is ~100-120px against a 71px card pitch, and Chrome snaps to
   whichever card is NEAREST the wheel's destination, which is often the one
   after next. So the wheel is taken over here: each notch — or one swipe's
   worth of trackpad deltas — moves exactly one card, then input is ignored
   until the move finishes.

   Delegated on document, because the drawer footer is replaced with server
   HTML on every cart change and a listener on the list would die with it.
   ========================================================================== */
(() => {
  const SELECTOR = '.uc-cart-recs scroll-carousel';
  const THRESHOLD = 25;   // px of accumulated delta that counts as one step
  const LOCK_MS = 380;    // roughly one smooth scroll
  let acc = 0;
  let lockedUntil = 0;

  document.addEventListener('wheel', (event) => {
    if (!window.matchMedia('(min-width: 700px)').matches) return;
    const list = event.target.closest && event.target.closest(SELECTOR);
    if (!list || Math.abs(event.deltaY) < Math.abs(event.deltaX)) return;

    const cards = list.querySelectorAll('.horizontal-product');
    const max = list.scrollHeight - list.clientHeight;
    if (cards.length < 2 || max <= 0) return;

    event.preventDefault();
    if (Date.now() < lockedUntil) return;

    acc += event.deltaY;
    if (Math.abs(acc) < THRESHOLD) return;

    const origin = cards[0].offsetTop;
    const tops = Array.from(cards, (card) => Math.min(card.offsetTop - origin, max));
    const current = tops.reduce((best, top, i) =>
      Math.abs(top - list.scrollTop) < Math.abs(tops[best] - list.scrollTop) ? i : best, 0);
    const next = Math.max(0, Math.min(tops.length - 1, current + (acc > 0 ? 1 : -1)));

    acc = 0;
    lockedUntil = Date.now() + LOCK_MS;
    list.scrollTo({ top: tops[next], behavior: 'smooth' });
  }, { passive: false });
})();

/* ==========================================================================
   CART DRAWER — the duties notice opens as a MODAL on desktop too
   --------------------------------------------------------------------------
   Theme popovers are a bottom-sheet modal below 1000px and a small anchored
   dropdown above it, positioned inside whatever contains them — here the
   drawer footer, so on desktop it landed in the drawer's corner over the line
   items. This one is told to mount on <body> at every width (the theme already
   does so below 1000px, and puts it back on close), and custom.css centres it
   with the overlay. Set on click, capture phase, because the drawer footer —
   and this element with it — is re-rendered on every cart change.
   ========================================================================== */
document.addEventListener('click', (event) => {
  const trigger = event.target.closest && event.target.closest('[aria-controls="uc-cart-duties-popover"]');
  if (!trigger) return;
  const popover = document.getElementById('uc-cart-duties-popover');
  if (popover && !Object.prototype.hasOwnProperty.call(popover, 'shouldAppendToBody')) {
    Object.defineProperty(popover, 'shouldAppendToBody', { get: () => true });
  }
}, true);
